import React, { useState } from 'react';
import '../styles/About.css';
import foot from '../assets/fot3.webp'
import basket from '../assets/basket2.webp'
import tennis from '../assets/lawn7.webp'
import valley from '../assets/valley3.webp'
import BookingModal from './BookingModal'; // Import the BookingModal component

const About = () => {
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal

  // Stats data
  const stats = [
    { number: '50+', label: 'Sports Grounds', icon: 'fa-map-marked-alt' },
    { number: '8', label: 'Sports Categories', icon: 'fa-futbol' },
    { number: '5000+', label: 'Happy Customers', icon: 'fa-smile' },
    { number: '24/7', label: 'Booking Support', icon: 'fa-headset' }
  ];

  // Features data
  const features = [
    {
      icon: 'fa-calendar-check',
      title: 'Easy Booking',
      description: 'Book your favorite sports ground in just a few clicks with our simple and fast booking process.'
    },
    {
      icon: 'fa-clock',
      title: '24/7 Availability',
      description: 'Book anytime, anywhere with our round-the-clock booking system. Never miss a game!'
    },
    {
      icon: 'fa-tag',
      title: 'Best Prices',
      description: 'Get the best rates and exclusive deals on all sports grounds across Dubai.'
    },
    {
      icon: 'fa-shield-alt',
      title: 'Secure Payment',
      description: 'Your transactions are 100% secure with our encrypted payment gateway.'
    },
    {
      icon: 'fa-star',
      title: 'Premium Grounds',
      description: 'Access to the best maintained and equipped sports facilities in Dubai.'
    },
    {
      icon: 'fa-headset',
      title: 'Dedicated Support',
      description: 'Our customer support team is always ready to assist you with any queries.'
    }
  ];

  // Testimonials data
  const testimonials = [
    {
      name: 'Ahmed Khan',
      role: 'Football Enthusiast',
      image: 'https://randomuser.me/api/portraits/men/32.jpg',
      text: 'BookMyGround has transformed how we book football matches. The process is seamless and the grounds are always top-notch!',
      rating: 5
    },
    {
      name: 'Sarah Williams',
      role: 'Tennis Player',
      image: 'https://randomuser.me/api/portraits/women/44.jpg',
      text: 'I love how easy it is to find and book tennis courts. The location filters save so much time!',
      rating: 5
    },
    {
      name: 'Mohammed Al Ali',
      role: 'Cricket Captain',
      image: 'https://randomuser.me/api/portraits/men/46.jpg',
      text: 'Our team uses BookMyGround exclusively for all our cricket matches. Great prices and excellent ground quality!',
      rating: 5
    }
  ];

  // Function to open modal
  const openModal = (e) => {
    if (e) e.preventDefault(); // Prevent default anchor behavior
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="about-container" id="about">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="hero-content">
              <h1 className="hero-title">
                <span className="title-highlight">About</span> BookMyGround
              </h1>
              <p className="hero-subtitle">
                Your Ultimate Sports Ground Booking Platform in Dubai
              </p>
              <div className="hero-description">
                <p>
                  We're on a mission to make sports accessible to everyone by providing 
                  a seamless platform to discover and book the best sports grounds across Dubai.
                </p>
              </div>
              
              {/* Stats Section */}
              <div className="stats-grid">
                {stats.map((stat, index) => (
                  <div className="stat-card" key={index}>
                    <div className="stat-icon">
                      <i className={`fas ${stat.icon}`}></i>
                    </div>
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Our Story Section */}
        <section className="story-section">
          <div className="container">
            <div className="story-grid">
              <div className="story-content">
                <h2 className="section-title">
                  Our <span>Story</span>
                </h2>
                <p className="story-text">
                  Founded in 2024, BookMyGround was born from a simple idea: 
                  making sports ground booking as easy as ordering food online.
                </p>
                <p className="story-text">
                  What started as a small initiative has now grown into Dubai's 
                  most trusted sports ground booking platform, connecting thousands 
                  of sports enthusiasts with the best facilities across the city.
                </p>
                <div className="mission-box">
                  <i className="fas fa-bullseye"></i>
                  <div>
                    <h3>Our Mission</h3>
                    <p>To create a healthier, more active community by making sports facilities accessible to everyone.</p>
                  </div>
                </div>
                <div className="vision-box">
                  <i className="fas fa-eye"></i>
                  <div>
                    <h3>Our Vision</h3>
                    <p>To be the #1 sports ground booking platform in the UAE and beyond.</p>
                  </div>
                </div>
              </div>
              <div className="story-image">
                <div className="image-grid">
                  <div className="grid-item item1">
                    <img src={foot} alt="Football Ground" />
                  </div>
                  <div className="grid-item item2">
                    <img src={basket} alt="Basketball Court" />
                  </div>
                  <div className="grid-item item3">
                    <img src={tennis} alt="Tennis Court" />
                  </div>
                  <div className="grid-item item4">
                    <img src={valley} alt="Volleyball Court" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="features-section">
          <div className="container">
            <h2 className="section-title center">
              Why Choose <span>Us?</span>
            </h2>
            <p className="section-subtitle">
              Experience the best sports ground booking service in Dubai
            </p>
            
            <div className="features-grid">
              {features.map((feature, index) => (
                <div className="feature-card" key={index}>
                  <div className="feature-icon">
                    <i className={`fas ${feature.icon}`}></i>
                  </div>
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="testimonials-section">
          <div className="container">
            <h2 className="section-title center">
              What Our <span>Customers Say</span>
            </h2>
            <p className="section-subtitle">
              Join thousands of satisfied sports enthusiasts
            </p>

            <div className="testimonials-grid">
              {testimonials.map((testimonial, index) => (
                <div className="testimonial-card" key={index}>
                  <div className="testimonial-header">
                    <img src={testimonial.image} alt={testimonial.name} />
                    <div>
                      <h4>{testimonial.name}</h4>
                      <p>{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i className="fas fa-star" key={i}></i>
                    ))}
                  </div>
                  <p className="testimonial-text">"{testimonial.text}"</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2>Ready to Play?</h2>
              <p>Join thousands of sports enthusiasts who trust BookMyGround for their game bookings</p>
              <div className="cta-buttons">
                <a 
                  href="#" 
                  className="cta-btn primary"
                  onClick={openModal}
                >
                  <i className="fas fa-calendar-check"></i>
                  Book a Ground Now
                </a>
                <a 
                  href="tel:+971542921340" 
                  className="cta-btn secondary"
                >
                  <i className="fas fa-phone-alt"></i>
                  Contact Us
                </a>
              </div>
              <div className="trust-badges">
                <span><i className="fas fa-shield-alt"></i> 100% Secure</span>
                <span><i className="fas fa-clock"></i> Instant Confirmation</span>
                <span><i className="fas fa-headset"></i> 24/7 Support</span>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Booking Modal */}
      <BookingModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default About;